<template>
    <div
        class="kleptos-header-energy"
        :class="'is-'+energyType"
    >
        <!-- ENERGY ICON -->
        <span class="kleptos-header-energy-icon"></span>

        <!-- ENERGY CELLS -->
        <div class="kleptos-energy-cells">
            <div
                v-for="(item, index) in energyCells"
                class="kleptos-energy-cell"
                :class="{ 'is-active': item.active }"
            >
                <div class="kleptos-energy-cell-fill"></div>
            </div>
        </div>

        <!-- ENERGY COUNTER -->
        <div
            class="kleptos-header-energy-bar-counter"
            :style="{ width: energyCounterWidth }"
            @click="mineEnergy"
        >
            {{ totalEnergy }}
        </div>

        <!-- ENERGY LIMITER -->
        <div
            v-if="energyType == 'blue'"
            class="kleptos-energy-limiter"
        >
            <span class="bar-1"></span>
            <span class="bar-2"></span>
            <span class="bar-3"></span>
            <span class="bar-4"></span>
        </div>

        <div
            v-if="energyType == 'red'"
            class="kleptos-energy-limiter"
        >
            <span class="kleptos-energy-gauge"></span>
        </div>

    </div>
    <!-- <p style="color: white;" :class="{ 'active': item.active }" v-for="item in energyCells">{{ item }}</p> -->
</template>

<script>
    export default {
        props: {
            energyType: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                energyCells: [
                    { active: false },
                    { active: false },
                    { active: false },
                    { active: false },
                    { active: false },
                    { active: false }
                ],
                // activeCell: 0,
                cellValue: 10,
                totalEnergy: 0,
                speed: 1000
            }
        },
        computed: {
            // speed(){
                // return 1000;
            // },
            energyCounterWidth(){
                let digitWidth = 7;
                let digits = this.totalEnergy.toString().length;
                let xPadding = 20;
                let output = (digits < 2 ? digitWidth : digitWidth * digits) + xPadding + 'px';
                return output;
            },

            // ACTIVE CELL ****************

            activeCell(){
                for (let i = 0; i < this.energyCells.length; i++) {
                    // return active cell - otherwise init with [0]
                    return this.energyCells[i].active ? this.energyCells[i] : this.energyCells[0];
                }
            }
        },
        methods: {
            mineEnergy(command){
                var self = this;
                var count = 0;

                self.speed += 20;

                if (self.interval) return; // no duplicates

                self.activeCell.active = true; // start at the cell we left off (if it's stopped)

                function timer(){
                    var lastItem = self.energyCells.pop();
                    lastItem.active = true;
                    self.energyCells.unshift(lastItem);
                    count++;

                    // At the end. Reset cells.
                    if (count == self.energyCells.length+1) {
                        count = 0;
                        self.resetCells();

                        // the main energy update:
                        self.totalEnergy += (self.cellValue * self.energyCells.length);
                    }
                }

                this.resetCells = function(){
                    for (let i = 0; i < self.energyCells.length; i++) {
                        self.energyCells[i].active = false;
                    }
                }

                self.interval = setInterval(timer, self.speed);
                // clearInterval(self.interval);
            },
        }
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // HEADER ENERGY
    //-----------------------------------------------------------------

    .kleptos-header-energy {
        display: flex;
        align-items: center;
        height: 100%;
        padding: 0 10px;

        &.is-red {
            flex-direction: row-reverse;
            margin-left: auto;
        }
    }

    //-----------------------------------------------------------------
    // ENERGY ICON
    //-----------------------------------------------------------------

    .kleptos-header-energy-icon {
        margin: rem-calc(0 10);
        // font-size: 16px;
        // color: #4f4f4f;
        width: rem-calc(19);
        height: 100%;
        // height: rem-calc(18);
        background: url(~@/assets/img/energy-icon.svg) no-repeat center center;
        background-size: contain;
        // opacity: 0.8;
        // animation: blink 1.5s linear infinite alternate;
        // transform-origin: center;
        // transition: opacity 1s ease;
    }

    @keyframes blink {
        // from { opacity: 1; }
        // to { opacity: 0.6; }
        // from { transform: rotate(0deg); }
        // to   { transform: rotate(359deg); }
    }

    //-----------------------------------------------------------------
    // ENERGY CELLS (BAR)
    //-----------------------------------------------------------------

    .kleptos-energy-cells {
        display: flex;

        .kleptos-energy-cell {
            position: relative;
            box-sizing: content-box;
            width: 28px;
            height: 5px;
            margin: 0 2px;
            border-bottom: 1px solid rgba(white, 0.18);
            border-radius: 50px;
            background: black;

            &.is-active .kleptos-energy-cell-fill {
                transform: scaleX(1);
                opacity: 1;
            }

            .kleptos-energy-cell-fill {
                box-sizing: content-box;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 4px;
                border-radius: 50px;
                background: #00cbff;
                border-bottom: 1px solid rgba(black, 0.5);
                box-shadow: 0px 1px 3px 1px rgba(darken(#00cbff, 20%), 0.5);
                transform: scaleX(0.3);
                opacity: 0;
                transition: all 500ms ease;
            }
        }
    }

    // IS RED !!!!
    .is-red {
        .kleptos-energy-cell .kleptos-energy-cell-fill {
            background: red;
            border-bottom: 1px solid rgba(black, 0.5);
            box-shadow: 0px 1px 3px 1px rgba(darken(red, 20%), 0.5);
        }

        .kleptos-energy-cells {
            flex-direction: row-reverse;
        }
    }

    //-----------------------------------------------------------------
    // ENERGY COUNTER
    //-----------------------------------------------------------------

    .kleptos-header-energy-bar-counter {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        margin: 0 15px; // [LOCKED]
        background: rgba(black, 0.3);
        font-size: 12px;
        font-weight: 500;
        text-align: center;
        color: #ccc;
        overflow: hidden;
        transition: width 200ms ease;
    }

    //-----------------------------------------------------------------
    // ENERGY LIMITER (GAUGE)
    //-----------------------------------------------------------------

    .kleptos-energy-limiter {
        display: flex;
        align-items: flex-end;

        .fa {
            color: #ff3317;
            line-height: 0;
        }

        .bar-1,
        .bar-2,
        .bar-3,
        .bar-4 {
            display: inline-block;
            width: 5px;
            margin-right: 2px;
        }

        .bar-1 {
            height: 5px;
            background-color: #2c2c2c;
        }
        .bar-2 {
            height: 10px;
            background-color: #2a2a2a;
        }
        .bar-3 {
            height: 15px;
            background-color: #3b3b3b;
        }
        .bar-4 {
            height: 20px;
            background-color: #4b4b4b;
        }
    }

    .kleptos-energy-gauge {
        width: 44px;
        height: 22.5px;
        background: url(~@/assets/img/energy-gauge.svg) no-repeat;
        background-size: contain;
    }

    // what is this?
    // .active {
    //     background: #2c272d;
    // }
</style>